import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import React from 'react';
import { Image } from 'components/Image/Image';
import { useComplexState } from 'hook/helper.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { ALERT } from 'externals/_tracking/types/clickEventTypes.constants';
import { useSeenNotificationPixel } from 'hook/helper.hook';
import { getAttributesSeenNotification } from 'helpers/tracking.helpers';
import { Link } from 'components/navigation/Link/Link';

const FactorNotificationComponent = props => {
  const { notification, icon, urlToNotification, history, eventHandler } =
    props;
  const [state, setState] = useComplexState({
    viewNotification: true,
  });
  const closeNotification = () => {
    setState({
      viewNotification: false,
    });
  };
  const onClickGoToNotificationCenter = () => {
    eventHandler(CLICK, {
      'Click Type': ALERT,
      'Alert Name': notification,
    });
    history.push(urlToNotification);
  };
  let attributes = {
    notificationName: notification,
  };

  let trackingAttributes = getAttributesSeenNotification(attributes);
  const seenNotification = useSeenNotificationPixel(trackingAttributes);

  const handleEnterKeyPress = event => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      closeNotification();
    }
  };

  return (
    <>
      {state?.viewNotification && (
        <FlexContainer
          className={'flex-container margt8 border-rad8px bgRed025 format100'}
          padding={'padT16 padLR16'}
        >
          {seenNotification}
          <FlexContainer className={'margt16 marglr16'}>
            <Image className={icon} />
          </FlexContainer>
          <FlexContainer className={'margtb16 marglr16 format90'}>
            <Label type="body-2" className={'txtGrey400 m-text-14'}>
              {notification}{' '}
              <Link
                className="link-style-gray7 pointer"
                onClickCallback={() => onClickGoToNotificationCenter()}
                ariaLabel="View Notificacion"
              >
                View Notification
              </Link>
            </Label>
          </FlexContainer>
          <FlexContainer
            className={'marglr16 margt16 format10 pointer'}
            onClick={() => closeNotification()}
            tabIndex="0"
            onKeyDown={e => handleEnterKeyPress(e)}
            role="button"
            ariaLabel="notificacion close"
          >
            <Image className={'notificationCloseButton'} />
          </FlexContainer>
        </FlexContainer>
      )}
    </>
  );
};

export { FactorNotificationComponent };
